<!---Navbar-->
<div class="nav-bar-container outer-bar">
    <div class="nav-bar inner-bar">
        <div class="component-container ">
            <!-- left -->
            <div class="left-container">
                <!--logo-->

                <logo-component></logo-component>

                <!--my polls-->
                <div *ngIf="responsiveService.isScreenBig()" class="navigation-links whoo-normal-button">
                    <button mat-button *ngIf="authService.isLoggedIn" color="accent"
                        routerLink="{{trans.getRoutePath('myPolls')}}" class="my-polls-button">
                        {{ 'my-events' | transMigrated | async}}
                    </button>

                </div>
            </div>
            <!--blog-->


            <!-- right -->
            <div class="right-container">
                <nav-create-poll-button></nav-create-poll-button>
                <nav-menu-button></nav-menu-button>
            </div>
        </div>
        <div class="ellipse-container-container">
            <div class="ellipse-container">
                <div class="ellipse">
                </div>
            </div>
        </div>
    </div>

</div>